export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [5,[2]],
		"/(app)/admin": [6,[2,3]],
		"/(app)/admin/settings": [7,[2,3]],
		"/auth": [24],
		"/(app)/c/[id]": [8,[2]],
		"/error": [25],
		"/(app)/playground": [9,[2]],
		"/s/[id]": [26],
		"/(app)/workspace": [10,[2,4]],
		"/(app)/workspace/documents": [11,[2,4]],
		"/(app)/workspace/functions": [12,[2,4]],
		"/(app)/workspace/functions/create": [13,[2,4]],
		"/(app)/workspace/functions/edit": [14,[2,4]],
		"/(app)/workspace/models": [15,[2,4]],
		"/(app)/workspace/models/create": [16,[2,4]],
		"/(app)/workspace/models/edit": [17,[2,4]],
		"/(app)/workspace/prompts": [18,[2,4]],
		"/(app)/workspace/prompts/create": [19,[2,4]],
		"/(app)/workspace/prompts/edit": [20,[2,4]],
		"/(app)/workspace/tools": [21,[2,4]],
		"/(app)/workspace/tools/create": [22,[2,4]],
		"/(app)/workspace/tools/edit": [23,[2,4]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';